module.exports = (parcelRequire.load("ic8EN")).then(() => parcelRequire('c1HwP'));